export default __webpack_public_path__ + "static/media/saint-laurent.d601f458.jpg";